// extracted by mini-css-extract-plugin
module.exports = {"galleryGrid":"gallery-module--galleryGrid--1BMF8","galleryItem":"gallery-module--galleryItem--2uCAk","gallerySlider":"gallery-module--gallerySlider--1lefd"};